import { render } from "./SendedEmailsModal.vue?vue&type=template&id=08505d42"
import script from "./SendedEmailsModal.vue?vue&type=script&lang=js"
export * from "./SendedEmailsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__